(function () {
  if (window.CavernProductWishlistLoaded) return;
  window.CavernProductWishlistLoaded = true;

  const TOKEN_KEY = 'cavernCollectionSessionToken';
  const DEFAULT_ENDPOINT = 'https://cavern-app-backend.onrender.com';
  const DEFAULT_LOGIN_URL = '/pages/my-collection?tab=wishlist';

  function parseProductData(button) {
    const container = button.closest('[data-cavern-product-wishlist-container]') || button.closest('product-form');
    const script = container?.querySelector('[data-cavern-product-wishlist-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function selectedVariant(button, productData) {
    const productForm = button.closest('product-form');
    const variantId = productForm?.querySelector('[name="id"]')?.value;
    const variants = Array.isArray(productData?.variants) ? productData.variants : [];
    return variants.find((variant) => String(variant.id) === String(variantId)) || variants[0] || null;
  }

  function selectedCondition(variant) {
    const title = String(variant?.title || '').trim();
    if (!title || title.toLowerCase() === 'default title') return 'Any';
    return title;
  }

  function cleanSystemName(value) {
    return String(value || '')
      .replace(/\s*[-|]\s*the video game cavern\s*$/i, '')
      .replace(/\s+(video\s+)?games?$/i, '')
      .replace(/\s+consoles?$/i, '')
      .replace(/\s+systems?$/i, '')
      .replace(/\s+accessories$/i, '')
      .replace(/\s+controllers$/i, '')
      .trim();
  }

  function productSystem(productData) {
    return (
      cleanSystemName(productData?.vendor) ||
      cleanSystemName(productData?.type) ||
      cleanSystemName(productData?.productType) ||
      'Any system'
    );
  }

  function productImage(productData, variant) {
    return String(variant?.imageUrl || productData?.featuredImage || '').trim();
  }

  function productType(productData) {
    const source = String(productData?.type || productData?.productType || productData?.vendor || '').toLowerCase();
    if (source.includes('amiibo')) return 'Amiibo';
    if (source.includes('figure') || source.includes('skylander') || source.includes('disney infinity')) return 'Figure';
    if (source.includes('console') || source.includes('system')) return 'Console';
    if (source.includes('magazine')) return 'Magazine';
    return 'Game';
  }

  function endpoint(button) {
    return String(button.dataset.endpoint || DEFAULT_ENDPOINT).replace(/\/+$/, '');
  }

  function loginUrl(button) {
    return button.dataset.loginUrl || DEFAULT_LOGIN_URL;
  }

  function statusElement(button) {
    const container = button.closest('[data-cavern-product-wishlist-container]') || button.closest('product-form');
    return container?.querySelector('[data-cavern-product-wishlist-status]');
  }

  function setStatus(button, message, isError = false) {
    const status = statusElement(button);
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('product-form__wishlist-status--error', isError);
  }

  function setLoginStatus(button) {
    const status = statusElement(button);
    if (!status) return;
    const url = loginUrl(button);
    status.classList.add('product-form__wishlist-status--error');
    status.innerHTML = `Sign in through <a href="${url}">My Collection</a> to save wishlist items.`;
  }

  function setBusy(button, busy) {
    button.toggleAttribute('disabled', busy);
    button.setAttribute('aria-disabled', busy ? 'true' : 'false');
    button.classList.toggle('loading', busy);
    const label = button.querySelector('[data-cavern-product-wishlist-label]');
    if (label) label.textContent = busy ? 'Adding...' : button.dataset.defaultLabel || 'Add to wishlist';
  }

  function wishlistItem(productData, variant) {
    const title = String(productData?.title || '').trim();
    if (!title) throw new Error('Product title was not found.');
    return {
      title,
      consoleName: productSystem(productData),
      desiredCondition: selectedCondition(variant),
      targetPrice: null,
      notifyWhenInStock: true,
      imageUrl: productImage(productData, variant),
      itemType: productType(productData),
      upc: String(variant?.barcode || '').trim(),
    };
  }

  async function addToWishlist(button) {
    const token = localStorage.getItem(TOKEN_KEY) || '';
    if (!token) {
      setLoginStatus(button);
      return;
    }

    const productData = parseProductData(button);
    if (!productData) throw new Error('Product data was not found.');
    const variant = selectedVariant(button, productData);
    const item = wishlistItem(productData, variant);

    const response = await fetch(`${endpoint(button)}/api/wishlist`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ item }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.success === false) {
      if (response.status === 401) {
        localStorage.removeItem(TOKEN_KEY);
        setLoginStatus(button);
        return;
      }
      throw new Error(data.message || 'Could not add this item to your wishlist.');
    }

    setStatus(button, 'Added to your wishlist.');
  }

  async function handleWishlistClick(event) {
    const button = event.target.closest('[data-cavern-product-wishlist]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    button.dataset.defaultLabel = button.dataset.defaultLabel || button.textContent.trim() || 'Add to wishlist';
    setBusy(button, true);
    setStatus(button, '');
    try {
      await addToWishlist(button);
    } catch (error) {
      setStatus(button, error.message || 'Could not add this item to your wishlist.', true);
    } finally {
      setBusy(button, false);
    }
  }

  document.addEventListener('click', handleWishlistClick);
})();
